import React from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  DeleteBlackIcon,
  EditBlackIcon,
  MoreIcon,
  PublishIcon,
  UnpublishIcon
} from '@components/icons/svg-icon.tsx';
import { useTranslation } from 'react-i18next';
import { ServicesModel } from '@models/services.model.ts';

const ServicesActions: React.FC<{
  row: ServicesModel;
  handlePublish: (row: ServicesModel) => void;
  handleEdit: (row: ServicesModel) => void;
  handleDelete: (row: ServicesModel) => void;
}> = ({ row, handlePublish, handleEdit, handleDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { t } = useTranslation();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="!p-0 !h-[20px] !w-[20px]"
        disableRipple
        onClick={handleClickMenu}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        sx={{ minWidth: 200 }}
      >
        <MenuItem
          onClick={() => {
            handlePublish(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {row.isPublished ? <UnpublishIcon /> : <PublishIcon />}
          </ListItemIcon>
          {row.isPublished ? t('unpublish') : t('publish')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleEdit(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <EditBlackIcon />
          </ListItemIcon>
          {t('edit')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleDelete(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <DeleteBlackIcon />
          </ListItemIcon>
          {t('delete')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ServicesActions;
